import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../App.css";
import "./RedefinirSenhaPage.css";
import logo from "../../assets/img/logo-header.png";

import ResetTokenService from "../../services/PasswordResetTokenService";
import CadastrosService from "../../services/CadastrosService";

export default function RedefinirSenhaPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [form, setForm] = useState({
    senha: "",
    confirmarSenha: "",
  });

  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [senha, setSenha] = useState(null);
  const [confirmarSenha, setConfirmarSenha] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [tokenValido, setTokenValido] = useState(false);

  // =========================
  // Valida token ao abrir
  // =========================
  useEffect(() => {
    if (!token) {
      setErro("Token inválido ou inexistente.");
      return;
    }

    ResetTokenService.validar(token)
      .then(() => setTokenValido(true))
      .catch(() => setErro("Token inválido ou expirado."));
  }, [token]);

  // =========================
  // Validação
  // =========================
  function validarCampos() {
    if (!form.senha.trim()) return "Informe a nova senha.";
    if (!form.confirmarSenha.trim()) return "Confirme a nova senha.";
    if (form.senha !== form.confirmarSenha)
      return "As senhas não coincidem.";
    return null;
  }

  // =========================
  // Submit
  // =========================
  async function handleSubmit(e) {
    e.preventDefault();
    setErro("");
    setSucesso("");

    const erroValidacao = validarCampos();
    if (erroValidacao) {
      setErro(erroValidacao);
      return;
    }

    try {
      setCarregando(true);

      await ResetTokenService.redefinir({
          token,
          novaSenha: form.senha,
      });

      //await ResetTokenService.consumir(token);

      setSucesso("Senha redefinida com sucesso!");
      setTimeout(() => navigate("/login"), 2000);

    } catch (error) {
      setErro("Erro ao redefinir senha.");
    } finally {
      setCarregando(false);
    }
  }

  // =========================
  // Render
  // =========================
  if (!tokenValido) {
    return (
      <div className="reset-container">
        <p className="erro-msg">{erro}</p>
      </div>
    );
  }

  return (
    <div className="reset-container">
      <form className="reset-form" onSubmit={handleSubmit}>
        <img src={logo} alt="Logotipo" />
        <h2>REDEFINIR SENHA</h2>


        <input
          className="reset-inputs"
          type="password"
          placeholder="Nova senha"
          value={form.senha}
          onChange={(e) =>
            setForm({ ...form, senha: e.target.value })
          }
        />

        <input
          className="reset-inputs"
          type="password"
          placeholder="Confirmar nova senha"
          value={form.confirmarSenha}
          onChange={(e) =>
            setForm({ ...form, confirmarSenha: e.target.value })
          }
        />

        <button type="submit" disabled={carregando}>
          {carregando ? "Salvando..." : "Salvar senha"}
        </button>

        {erro && <p className="erro-msg">{erro}</p>}
        {sucesso && <p className="sucesso-msg">{sucesso}</p>}

        <button className="reset-link voltar" onClick={() => navigate('/Login')}>
          Voltar ao login
        </button>
      </form>
    </div>
  );
}
